import type { RouteObject } from "react-router";

/**
 * /login — the page behind redirects of protected routes and deep links. Lazy: its form code (zod, react-hook-form)
 * is not part of the first load of the storefront (D40).
 */
export const loginRoute: RouteObject = {
  path: "/login",
  lazy: async () => ({ Component: (await import("./ui/LoginPage")).LoginPage }),
};

/**
 * /verification/return — MyID's page sends the customer back here (ADR-0013); the address is registered at MyID, so it
 * never changes. Lazy: only customers coming back from MyID need it.
 */
export const verificationReturnRoute: RouteObject = {
  path: "/verification/return",
  lazy: async () => ({
    Component: (await import("./ui/VerificationReturnPage")).VerificationReturnPage,
  }),
};
